import { db } from '../firebase';
import firebase from 'firebase/app';

export async function getActiveBanners() {
  const now = new Date();
  const snapshot = await db.collection('banners')
    .where('startDate', '<=', now)
    .where('endDate', '>=', now)
    .orderBy('startDate', 'desc')
    .get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getBanners(opts = {}) {
  let query = db.collection('banners').orderBy('createdAt', 'desc');
  const snapshot = await query.get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getBannerById(id) {
  const doc = await db.collection('banners').doc(id).get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() };
}

export async function createBanner(data) {
  return db.collection('banners').add({
    ...data,
    startDate: firebase.firestore.Timestamp.fromDate(new Date(data.startDate)),
    endDate: firebase.firestore.Timestamp.fromDate(new Date(data.endDate)),
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function updateBanner(id, data) {
  return db.collection('banners').doc(id).update({
    ...data,
    startDate: firebase.firestore.Timestamp.fromDate(new Date(data.startDate)),
    endDate: firebase.firestore.Timestamp.fromDate(new Date(data.endDate)),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function deleteBanner(id) {
  return db.collection('banners').doc(id).delete();
}

export async function getTotalBanners() {
  const snapshot = await db.collection('banners').get();
  return snapshot.size;
}